
import { faHeadset, faHeartCircleCheck, faMap, faUserShield } from '@fortawesome/free-solid-svg-icons';


export const features = [
  {
    icon: faMap,
    title: 'International Network',
    description: 'Connect with trusted partners and destinations across 50+ countries for seamless global travel.'
  },
  {
    icon: faHeartCircleCheck,
    title: 'Top Rated',
    description: 'Rated 4.9★ by thousands of happy travelers for premium service and unforgettable trips.'
  },
  {
    icon: faUserShield,
    title: 'Best Security',
    description: 'Your safety is our priority — secure payments, verified tours, and trusted travel partners.'
  },
  {
    icon: faHeadset,
    title: 'Dedicated Support',
    description: 'Our expert team is available 24/7 to assist you from booking to boarding and beyond.'
  }
]

